const fadeIn = {
	fromStyle: { opacity: 0, transform: 'translateX(-200%) scale(0.5)' },
	toStyle: { opacity: 0.85, transform: 'translateX(-50%) scale(1)' },
	easing: 'easeOutBack'
};

const fadeOut = {
	fromStyle: { opacity: 0.85, transform: 'translateX(-50%) scale(1)' },
	toStyle: { opacity: 0, transform: 'translateX(200%) scale(0.5)' },
	easing: 'easeOutBack'
}

export default [
  	{
	    text: {
			'en': "Oswaldo is a third-generation Detroiter. Oswaldo's grandparents migrated from west-central Mexico to Detroit during the 70's to find better job opportunities.",
			'es': "Oswaldo es un Detroiter de tercera generación. Los abuelos de Oswaldo emigraron del centro-oeste de México a Detroit durante los años 70 para encontrar mejores oportunidades de trabajo"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
	    parallaxData: {
	    	start: 14800,
	    	end: 14900,
	    	...fadeOut
	    }
  	},
  	{
	    text: {
			'en': "Oswaldo's grandparents soon began to bring family and friends from Jalisco to also find home in Michigan. Over the years, they are able to build a tight-knit community in Southwest Detroit, a neighborhood now recognized for its vibrant Mexican culture.",
			'es': "Los abuelos de Oswaldo pronto comenzaron a traer familiares y amigos de Jalisco para que también encontraran un hogar en Michigan. A lo largo de los años, pudieron construir una comunidad muy unida en el suroeste de Detroit, un vecindario ahora reconocido por su vibrante cultura mexicana"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
	    parallaxData: [
		    {
		        start: 14900,
		        end: 15000,
		        ...fadeIn
		    },
		    {
		        start: 19800,
		        end: 19900,
		        ...fadeOut
		    }
	    ]
  	},
  	{
	    text: {
			'en': "In 2013, Oswaldo and his family move into a new home - a house once meant for his older brother as a wedding gift from their parents. His older brother's personal and financial problems over the years lead to Oswaldo taking responsibility for the home in his stead and moving in with his family.",
			'es': "En 2013, Oswaldo y su familia se mudan a una nueva casa, una casa que una vez fue destinada para su hermano mayor como regalo de bodas de sus padres. Los problemas personales y financieros de su hermano mayor a lo largo de los años llevaron a Oswaldo a asumir la responsabilidad de la casa en su estable y mudándose con su familia"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
	    parallaxData: [
		    {
		        start: 19900,
		        end: 20000,
		        ...fadeIn
		    },
		    {
		        start: 23800,
		        end: 23900,
		        ...fadeOut
		    }
	    ]
  	},
  	{
	    text: {
			'en': "Because his older brother took out a second mortgage, this gift of a home has unknowingly turned into a debt...and the bank is ready to collect. Oswaldo finds out his home is in foreclosure upon receiving a sudden letter in the mail, and with only 8 weeks to figure everything out, Oswaldo is left with few choices but to fight back.",
			'es': "Debido a que su hermano mayor obtuvo una segunda hipoteca, este regalo de una casa se ha convertido sin saberlo en una deuda... y el banco está listo para cobrar. Oswaldo descubre que su casa está en ejecución hipotecaria al recibir una carta repentina por correo, y con solo 8 semanas para resolver todo, a Oswaldo le quedan pocas opciones más que contraatacar"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
	    parallaxData: [
		    {
		        start: 23900,
		        end: 24000,
		        ...fadeIn
		    },
		    {
		        start: 27800,
		        end: 27900,
		        ...fadeOut
		    }
	    ]
  	},
  	{
	    text: {
			'en': "Determined to save his home, Oswaldo finds public notice of his home's foreclosure and imminent auction in a obscure legal ledger.",
			'es': "Decidido a salvar su casa, Oswaldo encuentra un aviso público de la ejecución hipotecaria y la subasta inminente de su casa en un oscuro libro de contabilidad"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/C.png',
	    parallaxData: [
		    {
		        start: 27900,
		        end: 28000,
		        ...fadeIn
		    },
		    {
		        start: 30600,
		        end: 30700,
		        ...fadeOut
		    }
	    ]
  	},
  	{
	    text: {
			'en': "With the help of friends and family, Oswaldo attends the auction in hopes of having enough cash to win his home back...but he's not the only bidder.The buyers at this auction don't want homes, they just want property. It's clear the buyers here are only interested in profit, not people.",
			'es': "Con la ayuda de amigos y familiares, Oswaldo asiste a la subasta con la esperanza de tener suficiente efectivo para recuperar su casa... pero no es el único postor. Los compradores en esta subasta no quieren casas, solo quieren propiedades. Está claro que los compradores aquí solo están interesados en las ganancias, no en las personas"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
	    parallaxData: [
		    {
		        start: 30700,
		        end: 30800,
		        ...fadeIn
		    },
		    {
		        start: 32600,
		        end: 32700,
		        ...fadeOut
		    }
	    ]
  	},
  	{
	    text: {
			'en': "Oswaldo finds himself up against a buyer who has come to the auction with a pre-written check of the exact amount needed to buy Oswaldo's home. He tries to appeal to the buyer, but they laugh in his face. However, while he may have been outbid, Oswaldo is not out of options.",
			'es': "Oswaldo se enfrenta a un comprador que ha venido a la subasta con un cheque preescrito de la cantidad exacta necesaria para comprar la casa de Oswaldo. Intenta apelar al comprador, pero se ríen en su cara. Sin embargo, aunque puede han sido superados, Oswaldo no se queda sin opciones"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/E.png',
	    parallaxData: [
		    {
		        start: 32700,
		        end: 32800,
		        ...fadeIn
		    },
		    {
		        start: 34200,
		        end: 34300,
		        ...fadeOut
		    }
	    ]
  	},
  	{
	    text: {
			'en': "Backed by the power of his community, Oswaldo is able to win back his house through a process called 'redemption': a legal practice where one can still reclaim their home after the home has already been sold at a foreclosure sale.",
			'es': "Respaldado por el poder de su comunidad, Oswaldo puede recuperar su casa a través de un proceso llamado 'redención': una práctica legal en la que uno aún puede reclamar su casa después de que la casa ya se haya vendido en una venta de ejecución hipotecaria"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/F.png',
	    parallaxData: [
		    {
		        start: 34300,
		        end: 34500,
		        ...fadeIn
		    },
		    {
		        start: 36900,
		        end: 37000,
		        ...fadeOut
		    }
	    ]
  	},
  	{
	    text: {
			'en': "Today, Oswaldo still lives in this home with a clean title and cleared debt. He hopes to keep this home in the family for his children and their children for years to come.",
			'es': "Hoy, Oswaldo todavía vive en esta casa con un título limpio y una deuda saldada. Espera mantener esta casa en la familia para sus hijos y las generaciones veniderass"
		},
	    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/F.png',
	    parallaxData: [
		    {
		        start: 37000,
		        end: 37200,
		        ...fadeIn
		    },
		    {
		        start: 38000,
		        end: 38100,
		        ...fadeOut
		    }
	    ]
  	},
];
